/* global SentryUserData */

import {init, setUser} from '@sentry/browser';

import {survivePageTranslation} from 'shared/page-translation';
import {
    DenyURLs,
    IgnoreErrors,
    addExtraContext,
    isInjectedNetworkFailure,
    isInjectedStack,
    isInjectedStackOverflow,
    isInjectedSyntaxError,
    isLocalCopy,
    isMissingGlobal,
    isThirdPartyEvent,
    matchesError,
} from 'shared/sentry-rules';

/* This bundle is the first script on every page — the one place from which the patch is certain to
   be in before any react of ours starts rendering. */
survivePageTranslation();

/* jQuery is served as a bundle of its own, so everything expecting it fails at once when that one
   file did not arrive. The page is broken then, but by the network rather than by us. A jQuery that
   is present and still reported missing would be worth seeing, which is what the check leaves in. */
const MissingJQueryPattern = /jQuery is not defined|find variable: jQuery/;

const isMissingJQuery = event => !window.jQuery && matchesError(event, MissingJQueryPattern);

/* Browsers without it are shown the notice in base.html instead of the site, so whatever they go on
   to report is a consequence of that and not something to look into. */
const isSupportedBrowser = Boolean(window.ResizeObserver);

if (process.env.NODE_ENV === 'production' && isSupportedBrowser) {
    init({
        dsn: 'https://c791a73cda4e451f961a8df94d8b7ec7@sentry.cosmocode.de/20',
        environment: window.SentryEnvironment,
        release: window.SentryRelease,
        denyUrls: DenyURLs,
        ignoreErrors: IgnoreErrors,
        beforeSend(event) {
            if (isThirdPartyEvent(event) || isInjectedStack(event)) return null;
            if (isInjectedStackOverflow(event) || isInjectedSyntaxError(event)) return null;
            if (isInjectedNetworkFailure(event)) return null;
            if (isLocalCopy(event) || isMissingJQuery(event) || isMissingGlobal(event)) return null;

            return addExtraContext(event);
        },
    });

    if (window.SentryUserData) setUser({...SentryUserData});
}
